export default {
  text: {
    order_cancelled: 'Order canceled - Driver not available',
    wolt_support: 'Questions? Call Wolt directly <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>URGENT:</strong> Accept or reject this order immediately',
  },
  labels: {
    dummy_order: 'Test order',
    items_one: '{{count}} item',
    items_other: '{{count}} items',
    needs_acceptance: 'Needs acceptance',
    driver_pending: 'Waiting for driver',
    today: 'Today',
    driver_assigned: 'Driver assigned',
    complete: 'Completed',
  },
  buttons: {
    complete_order: 'Mark as complete',
    looking_for_driver: 'Looking for a driver...',
    click_to_remove: 'Click to remove',
  },
};
